import { render } from "./App.vue?vue&type=template&id=ebc73736"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ebc73736&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b2b5edefead35d23a3b8220fad0c02df/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__